import { useSubscription } from '@/hooks/useSubscription';

interface SubscriptionGuardProps {
  children: React.ReactNode;
}

export function SubscriptionGuard({ children }: SubscriptionGuardProps) {
  const { isLoading, statusError, subscriptionStatus } = useSubscription();

  // If the status check errored (e.g. a 401 during the idle token-refresh
  // window), render the app rather than the false "expired" page. `isBlocked`
  // is already gated on a successful response, so this only affects which
  // fallback we show while the failure resolves.
  if (statusError) {
    return <>{children}</>;
  }

  // Genuine first load with no data yet — defer to the parent loading state.
  if (isLoading || !subscriptionStatus) {
    return null;
  }

  // A lapsed clinic is not locked out: it opens read-only (the API refuses
  // changes, ReadOnlyBanner in the shell says so and links to billing).
  return <>{children}</>;
}
